import type { FormikProps } from 'formik';
import { isEmpty } from 'lodash-es';
import { useEffect } from 'react';

/**
 * This is an helper hook to scroll first errored input,
 *
 * If form got a validation error when submiting.
 */
const useScrollToFirstErroredInput = <T,>({ formik }: { formik: FormikProps<T> }) =>
  useEffect(() => {
    if (!isEmpty(formik.errors)) {
      const el =
        document.querySelector('.Mui-error, [data-error]') ??
        document.getElementById(Object.keys(formik.errors)[0]);

      (el?.parentElement ?? el)?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }, [formik.isSubmitting]);

export default useScrollToFirstErroredInput;
